import { Component, forwardRef } from '@angular/core';
import { SelectOption } from '../../../modules/sources/components/source-configuration-list/components/configuration-tab/interfaces/select-option';
import { ExportFormat } from '../../../modules/data-collection/export-format';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { MatLegacySelectChange } from '@angular/material/legacy-select';

@Component({
  selector: 'mee-export-format',
  templateUrl: './export-format.component.html',
  styleUrls: ['./export-format.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => ExportFormatComponent),
    },
  ],
})
export class ExportFormatComponent implements ControlValueAccessor {
  formats: SelectOption[] = [
    {
      value: ExportFormat.ShapeFile,
      title: 'ExportFormat.ShapeFile',
    },
    {
      value: ExportFormat.GeoJson,
      title: 'ExportFormat.GeoJson',
    },
  ];

  exportFormatControl = new FormControl<number>(ExportFormat.ShapeFile);

  onChange: any = (): void => {};

  writeValue(format: number): void {
    this.exportFormatControl.setValue(format);
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {}

  onFormatChange({ value }: MatLegacySelectChange) {
    this.onChange(value);
  }
}
